<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">{{tempCategory.categoryType}}</span>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Title:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempCategory.name">
      </div>
    </div>


    <ng-container *ngIf="tempCategory.categoryType === 'MISC'">
      <div class="input-block">
        <div class="input-label">Lines QTY:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultLinesQty">
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="tempCategory.categoryType === 'MISC' || tempCategory.categoryType === 'ADDONS'">
      <div class="input-block">
        <div class="input-label">Misc List:</div>

        <div class="email-input-text" *ngIf="!miscItemLoading">
          <p-listbox [options]="miscItems" [(ngModel)]="tempCategory.miscList" [multiple]="true" [checkbox]="true"
                     [showToggleAll]="true" optionLabel="name" [filter]="true"
                     [ngModelOptions]="{standalone: true}" class="p-list-box-block">
          </p-listbox>
        </div>
      </div>
      <lib-mini-progress-spinner *ngIf="miscItemLoading"></lib-mini-progress-spinner>
    </ng-container>
    <ng-container *ngIf="tempCategory.categoryType !== 'MISC' && tempCategory.categoryType !== 'ADDONS'">
      <div class="input-block">
        <div class="input-label">QTY:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultQty">
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Width:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultWidth">
          <!--        <p-inputNumber class="arrow-input" BlockLateralArrowNavigation-->
          <!--                       [ngModelOptions]="{standalone: true}"-->
          <!--                       [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultWidth">-->
          <!--        </p-inputNumber>-->
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Height:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultHeight">
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Depth:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultDepth">
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Lines QTY:</div>

        <div class="email-input-text">
          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.defaultLinesQty">
        </div>
      </div>
      <div class="input-block">
        <div class="input-label">Box and Multiplier:</div>


        <div class="boxes-block">
          <p-inputSwitch class="arrow-input" [ngModelOptions]="{standalone: true}"
                         [disabled]="saveLoading" [(ngModel)]="tempCategory.isBox"></p-inputSwitch>

          <input class="arrow-input" type="tel" pKeyFilter="int" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempCategory.boxesMultiplier" *ngIf="tempCategory.isBox">
        </div>
      </div>
    </ng-container>

    <div class="input-block">
      <div class="input-label">Enabled:</div>

      <div class="email-input-text">
        <p-inputSwitch class="arrow-input" [ngModelOptions]="{standalone: true}"
                       [disabled]="saveLoading" [(ngModel)]="tempCategory.enabled"></p-inputSwitch>
      </div>
    </div>
  </div>

  <div class="save-btn-block">
    <div class="sav-btn-bloock">
      <div class="space-block">
      </div>

      <button mat-button class="save-btn" (click)="saveCategory()"
              [disabled]="saveLoading || !tempCategory.name"
              tabindex="1" type="submit"
              [ngClass]="{'disabled-button': saveLoading || !tempCategory.name}">

        <span *ngIf="!saveLoading">{{footerBtnString}}</span>
        <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
      </button>

      <div class="flex-box">
        <button *ngIf="footerBtnString === 'Save'" mat-button class="delete-task-button" (click)="deleteCategory()">
          <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
          <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
        </button>
      </div>

    </div>
  </div>
</div>
